import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Más de +100 clientes ya han pedido con nosotros de forma segura',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Más de +1.000 clientes ya han pedido con nosotros de forma segura',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Más de +10.000 clientes ya han pedido con nosotros de forma segura',
  },
};
